import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UtilService {


  constructor(private router: Router) { }

  navigate(path: string) {
    const vm = this;
    vm.router.navigate([path]);
  }

  getMinFormat(value) {
    return { year: new Date(value).getFullYear(), month: new Date(value).getMonth() + 1, day: new Date(value).getDate() };
  }

  /**
   * Fresh idempotency key for a money-path request.
   *
   * The backend's `requireIdempotencyKeyAtomic` middleware rejects anything that does not
   * match `/^(req_|srv_)[a-zA-Z0-9_-]+$/`; `srv_` is reserved for server-derived keys, so
   * client keys use the `req_` prefix. The middleware namespaces the key per admin user, so
   * it only has to be unique within one operator's own requests.
   *
   * Generate one key per logical operation and REUSE it when retrying that same operation —
   * that is what makes a retry safe (the server replays the first response instead of
   * crediting twice). Generate a NEW key for a genuinely new operation.
   */
  newIdempotencyKey(): string {
    const cryptoRef = (globalThis as any)?.crypto;
    if (cryptoRef?.randomUUID) {
      return 'req_' + cryptoRef.randomUUID().replace(/-/g, '');
    }
    if (cryptoRef?.getRandomValues) {
      const bytes = new Uint8Array(16);
      cryptoRef.getRandomValues(bytes);
      return 'req_' + Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    }
    // Last-resort fallback for non-secure contexts; uniqueness is all that is required here.
    return 'req_' + Date.now().toString(16) + Math.random().toString(16).slice(2, 10);
  }

}
